export interface BestProdiMatkulData {
    totalMatkul: number;
    matkulList: {
        namaMatkul: string,
        avgNilai: number,
        totalRiwayat: number, // riwayat nilai mahasiwa matkul ini
    }[];
}
function template1(data: BestProdiMatkulData, prodi: string, jumlahMatkul: number, periodeText?: string): string {
    const lines = data.matkulList.map(
        (d, i) => `${i + 1}. **${d.namaMatkul}** — rata-rata nilai **${d.avgNilai}** _(dari ${d.totalRiwayat} riwayat)_`
    );
    const teksJumlah = jumlahMatkul !== 0 ? `${jumlahMatkul} ` : '';
    const teksPeriode = periodeText ? ` dalam _${periodeText} terakhir_` : '';
    return `Daftar ${teksJumlah}matkul di prodi **${prodi}**${teksPeriode} beserta rata-rata nilainya:\n${lines.join('\n')}`;
}

function template2(data: BestProdiMatkulData, prodi: string, jumlahMatkul: number, periodeText?: string): string {
    const teksPeriode = periodeText ? ` dalam _${periodeText} terakhir_` : '';
    if (data.matkulList.length === 1) {
        const item = data.matkulList[0];
        return `Di prodi **${prodi}**${teksPeriode}, matkul **${item.namaMatkul}** punya rata-rata nilai **${item.avgNilai}** dari **${item.totalRiwayat}** riwayat data.`;
    }
    const lines = data.matkulList.map((d) => `**${d.namaMatkul}** (skor \`${d.avgNilai}\`, ${d.totalRiwayat} data)`);
    const teksJumlah = jumlahMatkul !== 0 ? `${jumlahMatkul}` : `${data.matkulList.length}`;
    return `Di prodi **${prodi}**${teksPeriode}, ada **${teksJumlah}** matkul dengan rata-rata nilai: ${lines.join(', ')}.`;
}

function template3(data: BestProdiMatkulData, prodi: string, jumlahMatkul: number, periodeText?: string): string {
    const lines = data.matkulList.map(
        (d) => `• **${d.namaMatkul}**: rata-rata **${d.avgNilai}** _(${d.totalRiwayat} riwayat)_`
    );
    const teksJumlah = jumlahMatkul !== 0 ? `${jumlahMatkul} ` : '';
    const teksPeriode = periodeText ? ` _(${periodeText} terakhir)_` : '';
    return `Rata-rata nilai ${teksJumlah}matkul di prodi **${prodi}**${teksPeriode}:\n\n${lines.join('\n\n')}`;
}

function template4(data: BestProdiMatkulData, prodi: string, jumlahMatkul: number, periodeText?: string): string {
    const lines = data.matkulList.map(
        (d, i) => `${i + 1}. **${d.namaMatkul}** \`(avg: ${d.avgNilai} | ${d.totalRiwayat} sampel)\``
    );
    const teksJumlah = jumlahMatkul !== 0 ? `${jumlahMatkul} ` : '';
    const teksPeriode = periodeText ? ` dalam _${periodeText} terakhir_` : '';
    return `📊 Berikut ${teksJumlah}matkul-matkul di prodi **${prodi}**${teksPeriode} beserta rata-rata nilainya:\n${lines.join('\n')}`;
}

function template5(data: BestProdiMatkulData, prodi: string, jumlahMatkul: number, periodeText?: string): string {
    const lines = data.matkulList.map((d) => `**${d.namaMatkul}** (rata-rata **${d.avgNilai}** dari ${d.totalRiwayat} riwayat)`);
    const teksJumlah = jumlahMatkul !== 0 ? `${jumlahMatkul} ` : '';
    const teksPeriode = periodeText ? ` _(${periodeText} terakhir)_` : '';
    return `Untuk prodi **${prodi}**${teksPeriode}, rata-rata nilai ${teksJumlah}matkulnya adalah: ${lines.join(', ')}.`;
}

// Fallback jika belum ada data (sekaligus perbaikan typo "me-terakhir")
function templateNotFound(prodi: string, jumlahMatkul: number, periodeText?: string): string {
    const teksJumlah = jumlahMatkul !== 0 ? `${jumlahMatkul} ` : '';
    const teksPeriode = periodeText ? ` dalam _${periodeText} terakhir_` : '';
    return `⚠️ Belum ada data ${teksJumlah}matkul untuk prodi **${prodi}**${teksPeriode}.`;
}

export function generateBestProdiMatkulResponse(
    data: BestProdiMatkulData,
    prodi: string,
    jumlahMatkul: number,
    periodeText?: string
): string {
    if (data.totalMatkul === 0 || data.matkulList.length === 0) {
        return templateNotFound(prodi, jumlahMatkul, periodeText);
    }

    const templates = [template1, template2, template3, template4, template5];
    const chosen = templates[Math.floor(Math.random() * templates.length)];
    return chosen(data, prodi, jumlahMatkul, periodeText);
}